const BenefitFinish = ({ backClick, disabled, siteId }) => {

  return (
    <div className="benefitfinishicon align-self-center justify-content-center text-center">
      <img src={`/${siteId}/benefitfinish.svg`} alt='benefit finish' className='w-25' />      
      <div className="benefit_title_infouse my-3">申し込みが完了しました。</div>
      <div className="benefit_summary_infouse">クーポン画面で特典をご確認ください。</div>
      <div className="text-center">
        <button
          disabled={disabled}
          className="button text-black bg-lightwhite buckbutton"
          onClick={backClick}>
          戻る
        </button>
      </div>
    </div>
  )
}

export default BenefitFinish;